import {
    SET_FLEET_ASSET_COMMENTS_HISTORY,
    SET_FLEET_ASSET_COMMENTS_SAVE
} from "./FleetAssetCommentsSaveType"

const initialState = {
    fleetAssetComments: false
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_FLEET_ASSET_COMMENTS_SAVE:
            return {
                ...state,
                fleetAssetComments: action.fleetAssetComments
            };
        case SET_FLEET_ASSET_COMMENTS_HISTORY:
            return {
                ...state,
                fleetAssetCommentsHistory: action.history
            };
        default:
            return state;
    }
};

export default reducer;